<div class="container-month-range">
  <div class="container-month-range__group">
    <mat-label class="container-month-range__group__label">{{ 'DATES.' + labelStartMonth | translate }}</mat-label>
    <mat-form-field>
      <input
        matInput
        [matDatepicker]="dpStart"
        [formControl]="startMonthControl"
        [max]="maxDate"
        readonly
        (click)="dpStart.open()"
        (focus)="dpStart.open()">
      <mat-hint>MM/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="dpStart"></mat-datepicker-toggle>
      <mat-datepicker #dpStart
                      startView="multi-year"
                      (monthSelected)="setStartMonthAndYear($event, dpStart)"
                      panelClass="month-picker">
      </mat-datepicker>
    </mat-form-field>
  </div>

  <div class="container-month-range__group">
    <mat-label class="container-month-range__group__label">{{'DATES.' +  labelEndMonth | translate }}</mat-label>
    <mat-form-field>
      <input
        matInput
        [matDatepicker]="dpEnd"
        [formControl]="endMonthControl"
        [max]="maxDate"
        readonly
        (click)="dpEnd.open()"
        (focus)="dpEnd.open()">
      <mat-hint>MM/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="dpEnd"></mat-datepicker-toggle>
      <mat-datepicker #dpEnd
                      startView="multi-year"
                      (monthSelected)="setEndMonthAndYear($event, dpEnd)"
                      panelClass="month-picker">
      </mat-datepicker>
    </mat-form-field>
  </div>
</div>